export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0F4C3A" />
    <path d="M18 46V18h6v22h14v6z" fill="#FAF8F5" />
    <path d="M44 12c1.2 5.6 2.4 6.8 8 8-5.6 1.2-6.8 2.4-8 8-1.2-5.6-2.4-6.8-8-8 5.6-1.2 6.8-2.4 8-8z" fill="#C59B27" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className={`leading-none ${light ? "text-[#FAF8F5]" : "text-[#121518]"}`}>
      <span className="font-serif-d text-xl font-semibold tracking-tight block">Limpeza Rápida</span>
      <span className="font-mono-d text-[10px] tracking-[0.35em] text-[#C59B27]">SÃO PAULO</span>
    </span>
  </span>
);
